import axios from '../api/axios';

export async function getCarHouseVehicles(carHouseId, pagination, options) {

  const headers = {
    'page': pagination.page,
    'limit': pagination.total,
  };

  options['headers'] = headers;


  const res = await axios.get(`carHouses/${carHouseId}/vehicles`, options);
  const data = {
    vehicles: res.data.results,
    count: res.data.count,
  };
  return data;
}